module.exports = __webpack_public_path__ + "static/media/hammer.589ccd97.svg";